const canonicalize = (value: unknown): unknown => {
  if (Array.isArray(value)) {
    return value.map((entry) => canonicalize(entry));
  }

  if (value && typeof value === "object") {
    if (value instanceof Date) {
      return value.toISOString();
    }

    const input = value as Record<string, unknown>;
    const output: Record<string, unknown> = {};

    Object.keys(input)
      .sort()
      .forEach((key) => {
        output[key] = canonicalize(input[key]);
      });

    return output;
  }

  return value;
};

export const stableHash = (value: unknown): string =>
  JSON.stringify(canonicalize(value));
